/* React-Redux */
import { createAsyncThunk } from "@reduxjs/toolkit";

/* Axios */
import axiosInterceptor from "src/utils/helper/axios-interceptor";

/* Utils */
import { createCookies } from "src/utils/helper/cookies";
import { ClientError } from "src/utils/status-handling/ClientError";

/* Interfaces */
import { AuthProps } from "src/shared/interfaces/common/Auth";

/**
 * loginWithGoogle uses the Google API to authenticated a users.
 * After authentication, the token received from Google is exchanged
 * for a token from Keycloak. This process is called "token exchange".
 */
export const loginWithGoogle = createAsyncThunk<
  AuthProps,
  string,
  { rejectValue: ClientError }
>(
  "loginWithGoogle",
  async (accessToken: string, { rejectWithValue }) => {
    try {
      const response = await axiosInterceptor.post(
        "/token_exchange",
        {
          access_token: accessToken,
        }
      );
      return createCookies(response);
    } catch (error) {
      return rejectWithValue(ClientError.unexpected());
    }
  }
);
